import { UserRole, UserRoleForm } from '@models/.';
import { transformPermissionForm } from '..';

export function transformToData(userRole: UserRole | null): UserRole | null {
  if (!userRole) return null;
  
  return {
    ...userRole,
  };
}

export function transformToForm(userRole: UserRole): UserRoleForm | null {
  if (!userRole) return null;
  
  const {
    id,
    nombre: name,
    fechaCreacion: creationDate,
    fechaActualizacion: updateDate,
    permisos: permissions
  } = userRole
  
  return {
    id,
    name,
    creationDate,
    updateDate,
    permissions: permissions
      .map((permission) => (transformPermissionForm(permission)))
      .filter((permission) => !!permission),
  };
}